<app-reise [reise]="funweek"></app-reise>
